__turbopack_context__.v({
  "icon": "oN8QcW_icon",
  "number": "oN8QcW_number",
  "p-font-serif": "oN8QcW_p-font-serif",
  "p-serif": "oN8QcW_p-serif",
  "ql-editor": "oN8QcW_ql-editor",
  "ql-snow": "oN8QcW_ql-snow",
  "u-typography-body": "oN8QcW_u-typography-body",
  "u-typography-h1": "oN8QcW_u-typography-h1",
  "u-typography-h2": "oN8QcW_u-typography-h2",
  "u-typography-h3": "oN8QcW_u-typography-h3",
  "u-typography-h4": "oN8QcW_u-typography-h4",
  "u-typography-h5": "oN8QcW_u-typography-h5",
  "u-typography-h6": "oN8QcW_u-typography-h6",
  "u-typography-h7": "oN8QcW_u-typography-h7",
});
